import { useLayoutEffect } from "preact/hooks";
import { isPWA } from "services/utils";

export const usePageTitle = (pageTitle: string) => {
    useLayoutEffect(() => {
        const old = document.title;
        setPageTitle(pageTitle);
        return () => {
            document.title = old;
        }
    }, [pageTitle]);
};

export const setPageTitle = (pageTitle: string) => {
    const pwa = isPWA();
    document.title = `${pageTitle}${!pageTitle || pwa ? "" : " - "}${pwa ? "" : getSiteTitle()}`;
}

function getSiteTitle() {
    return document.location.hostname.includes("intelligence.com") ? "Machine Intelligence" : "Exocortex";
}
